import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";
import Swal from "sweetalert2";
import Loader from "../shared/Loader/Loader";
const imageStoraeKey = `347525e64775187aed4d03329dbe793a`;

const FileTag = ({
  name,
  defaultValue,
  multiple,
  label,
  length,
  required,
  handleSingleDelete,
  isGalleryFile,
}) => {
  const [value, setValue] = useState(defaultValue?.url);
  const [preview, setPreview] = useState(defaultValue?.url);
  const [loading, setLoading] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleFileChange = async (event) => {
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("image", image);
    const url = `https://api.imgbb.com/1/upload?key=${imageStoraeKey}`;
    setLoading(true);
    await fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setValue(result.data.url);
          setLoading(false);
        }
      });

    setPreview(URL.createObjectURL(event.target.files[0]));
  };

  const handleDelete = async () => {
    if (isGalleryFile) {
      setVisibility(false);
    } else {
      const res = await handleSingleDelete(defaultValue._id);
      if (typeof res === "boolean" && res === true) {
        setVisibility(false);
      }
    }
  };

  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-center w-full" : "hidden"}
    >
      <div className="w-full relative pt-8">
        <label
          className="flex justify-center w-full h-32 transition bg-white border border-gray-300 dark:border-darkBorder rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none"
          style={{
            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8)),url('${preview}')`,
            backgroundSize: "cover",
          }}
        >
          <span className="absolute top-0 left-0 font-semibold cursor-default capitalize text-darkPrimary dark:text-darkWhite">
            {length ? label + " " + length : label}
          </span>
          <span className="flex flex-col justify-center items-center space-x-2 text-white">
            {loading ? (
              <Loader />
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  />
                </svg>
                <span className="font-medium text-center ">
                  Click to upload
                </span>
                {/* <span className="font-medium text-center capitalize">
                  {visibility ? (length ? label + " " + length : label) : ""}
                </span> */}
              </>
            )}
          </span>
          <input
            onChange={handleFileChange}
            type="file"
            name={visibility ? name : ""}
            className="hidden"
            src={value}
            alt={defaultValue?._id ? defaultValue?._id : ""}
            accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
          />
        </label>
      </div>
      <div className={!multiple ? "hidden" : ""}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn btn-sm btn-circle border border-gray-400 rounded-full mt-8 p-2 hover:bg-gray-50"
          title="Remove"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default FileTag;
